// extracted by mini-css-extract-plugin
module.exports = {"link":"Website-module--link--1gT72"};